import React, { useEffect, useState } from 'react';
import { X, Save, User, FileText } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../api';
import { mensajeErrorApi } from '../apiErrors';

const VACIO_FACTURACION = {
  facturacion_nombre_razon_social: '',
  facturacion_ruc_cedula: '',
  facturacion_direccion: '',
  facturacion_telefono: '',
  facturacion_correo: '',
};

export default function PerfilModal({ onClose }) {
  const [cargando, setCargando] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [clienteId, setClienteId] = useState(null);
  const [nombreCompleto, setNombreCompleto] = useState('');
  const [correoLogin, setCorreoLogin] = useState('');
  const [perfil, setPerfil] = useState({
    cedula: '', whatsapp: '', direccion_entrega_default: '', ubicacion_maps_link: '',
  });
  const [mismoPerfil, setMismoPerfil] = useState(true);
  const [facturacion, setFacturacion] = useState(VACIO_FACTURACION);

  useEffect(() => {
    api.get('/mi-perfil/').then((res) => {
      const c = res.data.cliente;
      if (!c) return;
      setClienteId(c.id);
      setNombreCompleto(`${c.user.first_name} ${c.user.last_name}`.trim() || c.user.username);
      setCorreoLogin(c.user.email);
      setPerfil({
        cedula: c.cedula || '',
        whatsapp: c.whatsapp || '',
        direccion_entrega_default: c.direccion_entrega_default || '',
        ubicacion_maps_link: c.ubicacion_maps_link || '',
      });
      setMismoPerfil(c.facturacion_mismo_perfil);
      setFacturacion({
        facturacion_nombre_razon_social: c.facturacion_nombre_razon_social || '',
        facturacion_ruc_cedula: c.facturacion_ruc_cedula || '',
        facturacion_direccion: c.facturacion_direccion || '',
        facturacion_telefono: c.facturacion_telefono || '',
        facturacion_correo: c.facturacion_correo || '',
      });
    }).catch(() => toast.error('No se pudo cargar tu perfil.'))
      .finally(() => setCargando(false));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!clienteId) return;
    setGuardando(true);
    try {
      const payload = { ...perfil, facturacion_mismo_perfil: mismoPerfil };
      if (!mismoPerfil) Object.assign(payload, facturacion);
      await api.patch(`/clientes/${clienteId}/`, payload);
      toast.success('Perfil actualizado.');
      onClose();
    } catch (err) {
      toast.error(mensajeErrorApi(err, 'No se pudo actualizar tu perfil.'));
    } finally {
      setGuardando(false);
    }
  };

  // Vista previa de lo que se usará en la factura cuando "mismos datos" está activo.
  const previaFacturacion = {
    nombre: nombreCompleto,
    ruc: perfil.cedula || '(sin cédula registrada)',
    direccion: perfil.direccion_entrega_default || '(sin dirección registrada)',
    telefono: perfil.whatsapp || '(sin whatsapp registrado)',
    correo: correoLogin,
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3>Mi perfil</h3>
          <button className="btn-ghost" onClick={onClose}><X size={18} /></button>
        </div>

        {cargando ? (
          <p className="text-secondary">Cargando...</p>
        ) : (
          <form onSubmit={handleSubmit} className="form-stack">
            <div>
              <h4 style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: 'var(--spacing-3)' }}>
                <User size={16} /> Datos de contacto
              </h4>
              <div className="form-row">
                <div>
                  <label>Nombre</label>
                  <input value={nombreCompleto} disabled />
                </div>
                <div>
                  <label>Correo (usuario de acceso)</label>
                  <input value={correoLogin} disabled />
                </div>
              </div>
              <div className="form-row">
                <div>
                  <label>Cédula</label>
                  <input value={perfil.cedula} onChange={(e) => setPerfil({ ...perfil, cedula: e.target.value })} placeholder="1712345678" />
                </div>
                <div>
                  <label>WhatsApp</label>
                  <input value={perfil.whatsapp} onChange={(e) => setPerfil({ ...perfil, whatsapp: e.target.value })} placeholder="0999999999" />
                </div>
              </div>
              <div>
                <label>Dirección de entrega final en Ecuador</label>
                <textarea rows={2} value={perfil.direccion_entrega_default}
                  onChange={(e) => setPerfil({ ...perfil, direccion_entrega_default: e.target.value })}
                  placeholder="Calle, número, referencia, ciudad" />
                <p className="text-xs text-secondary" style={{ marginTop: '4px' }}>
                  Todos los paquetes se envían a domicilio.
                </p>
              </div>
              <div>
                <label>Link de ubicación (Google Maps)</label>
                <input type="url" value={perfil.ubicacion_maps_link}
                  onChange={(e) => setPerfil({ ...perfil, ubicacion_maps_link: e.target.value })}
                  placeholder="https://maps.app.goo.gl/..." />
                <p className="text-xs text-secondary" style={{ marginTop: '4px' }}>
                  Ayuda a que la entrega de última milla se realice de forma segura.
                </p>
              </div>
            </div>

            <hr style={{ border: 0, borderTop: '1px solid var(--color-border)', margin: 'var(--spacing-2) 0' }} />

            <div>
              <h4 style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: 'var(--spacing-3)' }}>
                <FileText size={16} /> Datos de facturación
              </h4>

              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 400, fontSize: '13px', color: 'var(--color-text-primary)', marginBottom: 'var(--spacing-3)' }}>
                <input type="checkbox" checked={mismoPerfil} onChange={(e) => setMismoPerfil(e.target.checked)} />
                Usar los mismos datos de mi perfil
              </label>

              {mismoPerfil ? (
                <div className="alert-info" style={{ marginBottom: 0 }}>
                  <div><strong>Nombre / Razón social:</strong> {previaFacturacion.nombre}</div>
                  <div><strong>RUC / Cédula:</strong> {previaFacturacion.ruc}</div>
                  <div><strong>Dirección:</strong> {previaFacturacion.direccion}</div>
                  <div><strong>Teléfono:</strong> {previaFacturacion.telefono}</div>
                  <div><strong>Correo:</strong> {previaFacturacion.correo}</div>
                </div>
              ) : (
                <div className="form-stack">
                  <div>
                    <label>Nombre completo o razón social</label>
                    <input value={facturacion.facturacion_nombre_razon_social}
                      onChange={(e) => setFacturacion({ ...facturacion, facturacion_nombre_razon_social: e.target.value })} />
                  </div>
                  <div className="form-row">
                    <div>
                      <label>RUC o cédula</label>
                      <input value={facturacion.facturacion_ruc_cedula}
                        onChange={(e) => setFacturacion({ ...facturacion, facturacion_ruc_cedula: e.target.value })} />
                    </div>
                    <div>
                      <label>Teléfono</label>
                      <input value={facturacion.facturacion_telefono}
                        onChange={(e) => setFacturacion({ ...facturacion, facturacion_telefono: e.target.value })} />
                    </div>
                  </div>
                  <div>
                    <label>Dirección</label>
                    <input value={facturacion.facturacion_direccion}
                      onChange={(e) => setFacturacion({ ...facturacion, facturacion_direccion: e.target.value })} />
                  </div>
                  <div>
                    <label>Correo electrónico</label>
                    <input type="email" value={facturacion.facturacion_correo}
                      onChange={(e) => setFacturacion({ ...facturacion, facturacion_correo: e.target.value })} />
                  </div>
                </div>
              )}
            </div>

            <div className="modal-actions">
              <button type="button" className="btn-secondary" onClick={onClose}>Cancelar</button>
              <button type="submit" className="btn-primary" disabled={guardando}>
                <Save size={16} /> {guardando ? 'Guardando...' : 'Guardar cambios'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
